import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { BankAccountFormData } from '@js/interfaces';

type Props = {
  selectList: {
    id: number;
    code: string;
    name: string;
    name_hira: string;
}[],
  fieldLabel: 'branch' | 'bank',
  register: UseFormRegister<BankAccountFormData>
  errors: { [name: string]: object | undefined }
}

export const RadioButtonList = (props: Props) => {
  const { selectList, fieldLabel, register, errors } = props;
  return (
    <ul>
      {selectList.map((item, index) => {
        return (
          <li className="form-column" key={item.id}>
            <label className="form-radio" htmlFor={`radio-button_${item.id}_${index}`}>
              <input {...register(`radio_button_${fieldLabel}`, { required: true })} type="radio" id={`radio-button_${item.id}_${index}`} value={item.id} className={`form-radio__input ${errors && 'is-error'}`} />
              <span className="form-radio__text">{item.name}</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
};
